export {default as CustomActivityIndicator} from './CustomActivityIndicator'